module.exports = __webpack_public_path__ + "media/services_overview/smart-invest-chart-bd334e10.webp";